import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import AddIcon from '@material-ui/icons/Add'
import ArrowBackIcon from '@material-ui/icons/KeyboardArrowLeft'
import ArrowNextIcon from '@material-ui/icons/KeyboardArrowRight'
import AccountCircle from '@material-ui/icons/AccountCircle'
import PersonIcon from '@material-ui/icons/PersonOutline'
import Drawer from '@material-ui/core/Drawer'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Divider from '@material-ui/core/Divider'
import { connect } from "react-redux"
import { I18n } from 'react-redux-i18n'

import ViewListIcon from '@material-ui/icons/ViewList'
import DateRangeIcon from '@material-ui/icons/DateRange'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import SettingsIcon from '@material-ui/icons/Settings'

import BackIcon from '@material-ui/icons/KeyboardArrowLeft'
import DoneIcon from '@material-ui/icons/Done'

import moment from 'moment'

import { Link } from 'react-router-dom'

import {previousMonth, nextMonth} from '../actions/calendarActions'
import {previousWeek, nextWeek} from '../actions/weekActions'
import {logout} from '../actions/userActions'
import {otherUserLogout} from '../actions/otherUserActions'
import {addNewAppointment, clearNewAppointment} from '../actions/newAppointmentActions'
import {updateAppointment} from '../actions/updateAppointmentActions'

import {history} from "../helpers/history"

const styles = {
  root: {
    flexGrow: 1,
    marginBottom: 55,
  },
  drawer: {
    width: 300
  },
  flex: {
    flex: 1,
    textAlign: 'center'
  },
  title: {
    fontSize: 16
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  addButton: {
    marginLeft: 20,
    marginRight: -12,
  },
  link: {
    textDecoration: 'none'
  },
  linkButton: {
    color: '#ffffff'
  }
};

class NavBar extends React.Component {
  state = {
    auth: true,
    anchorEl: null,
    left: false
  }

  handleChange = (event, checked) => {
    this.setState({ auth: checked });
  }

  handleMenu = event => {
    this.setState({ anchorEl: event.currentTarget });
  }

  handleClose = () => {
    this.setState({ anchorEl: null });
  }

  userLogout = () => {
    this.props.dispatch(logout())
  }

  otherUserLogout = () => {
    this.props.dispatch(otherUserLogout())
  }

  toggleDrawer = () => {
    this.setState({ left: !this.state.left})
  }

  nextMonth = () => {
    this.props.dispatch(nextMonth(this.props.calendar.date, this.props.user.user.id))
  }

  previousMonth = () => {
    this.props.dispatch(previousMonth(this.props.calendar.date, this.props.user.user.id))
  }

  nextWeek = () => {
    this.props.dispatch(nextWeek(this.props.week.date))
  }

  previousWeek = () => {
    this.props.dispatch(previousWeek(this.props.week.date))
  }

  addNewAppointmentEvent = () => {
    this.props.dispatch(addNewAppointment(this.props.newAppointment))
  }

  updateAppointmentEvent = () => {
    this.props.dispatch(updateAppointment(this.props.updateAppointment))
  }

  backEvent = () => {
    this.props.dispatch(clearNewAppointment())

    history.goBack()
  }

  render() {
    const { classes } = this.props;
    const { auth, anchorEl } = this.state;

    return (
      <div className={classes.root}>
        {(() => {
          switch(true) {
            case (this.props.router.location.pathname.substr(0,this.props.router.location.pathname.lastIndexOf('/')) === '/month'):
              return (
                <CalendarAppBar
                  classes={classes}
                  anchorEl={anchorEl}
                  auth={auth}
                  calendar={this.props.calendar}
                  i18n={this.props.i18n}
                  toggleDrawer={this.toggleDrawer}
                  handleMenu={this.handleMenu}
                  handleClose={this.handleClose}
                  nextMonth={this.nextMonth}
                  previousMonth={this.previousMonth} />
              )
            case (this.props.router.location.pathname.substr(0,this.props.router.location.pathname.lastIndexOf('/')) === '/week'):
              return (
                <WeekAppBar
                  classes={classes}
                  anchorEl={anchorEl}
                  auth={auth}
                  week={this.props.week}
                  toggleDrawer={this.toggleDrawer}
                  handleMenu={this.handleMenu}
                  handleClose={this.handleClose}
                  nextMonth={this.nextWeek}
                  previousMonth={this.previousWeek} />
                )
            case (this.props.router.location.pathname === '/appointment/new'):
              return(
                <NewAppointmentAppBar
                  classes={classes}
                  anchorEl={anchorEl}
                  auth={auth}
                  router={this.props.router}
                  addNewAppointment={this.addNewAppointmentEvent}
                  backEvent={this.backEvent} />
              )
            case (this.props.router.location.pathname.substr(0,this.props.router.location.pathname.lastIndexOf('/')) === '/appointment/edit'):
              return(
                <UpdateAppointmentAppBar
                  classes={classes}
                  anchorEl={anchorEl}
                  auth={auth}
                  router={this.props.router}
                  updateAppointment={this.updateAppointmentEvent}
                  backEvent={this.backEvent} />
              )
            case (this.props.router.location.pathname.substr(0,this.props.router.location.pathname.lastIndexOf('/')) === '/appointment/info'):
              return(
                <AppointmentAppBar
                  classes={classes}
                  anchorEl={anchorEl}
                  auth={auth}
                  router={this.props.router}
                  backEvent={this.backEvent} />
              )
            default:
              return(
                <DefaultAppBar
                  classes={classes}
                  anchorEl={anchorEl}
                  auth={auth}
                  router={this.props.router}
                  toggleDrawer={this.toggleDrawer}
                  handleMenu={this.handleMenu}
                  handleClose={this.handleClose}/>
              )
            }})()}

        <Drawer open={this.state.left} onClose={this.toggleDrawer}>
          <div
            tabIndex={0}
            role="button"
            onClick={this.toggleDrawer}
            onKeyDown={this.toggleDrawer}
            className={classes.drawer}>
            <List component="nav">
              <Link to={"/week/"+moment().format('YYYYMMDD')} className={classes.link}>
                <ListItem button>
                  <ListItemIcon>
                    <ViewListIcon />
                  </ListItemIcon>
                  <ListItemText primary={I18n.t('menu.week')} />
                </ListItem>
              </Link>
              <Link to={"/month/"+moment().format('YYYYMMDD')} className={classes.link}>
                <ListItem button>
                  <ListItemIcon>
                    <DateRangeIcon />
                  </ListItemIcon>
                  <ListItemText primary={I18n.t('menu.month')} />
                </ListItem>
              </Link>
            </List>
            <Divider />
            <List>
              <ListItem button>
                <ListItemIcon>
                  <AccountCircle />
                </ListItemIcon>
                <ListItemText primary={this.props.user.user.name} />
              </ListItem>
              { this.props.otherUser.loggedIn ? (
                  <Link to="/" className={classes.link}>
                    <ListItem button onClick={this.otherUserLogout}>
                      <ListItemIcon>
                        <PersonIcon />
                      </ListItemIcon>
                      <ListItemText primary={I18n.t('menu.logged_in_as') + ' ' + this.props.otherUser.user.user} secondary={I18n.t('menu.logged_in_as_logout')} />
                    </ListItem>
                  </Link>
                ) : (
                  <Link to="/other-user" className={classes.link}>
                    <ListItem button>
                      <ListItemIcon>
                        <PersonIcon />
                      </ListItemIcon>
                      <ListItemText primary={I18n.t('menu.login_other_user')} />
                    </ListItem>
                  </Link>
                )
              }

              <Link to="/login" className={classes.link}>
                <ListItem button onClick={this.userLogout}>
                  <ListItemIcon>
                    <ExitToAppIcon />
                  </ListItemIcon>
                  <ListItemText primary={I18n.t('menu.logout')} />
                </ListItem>
              </Link>
              <Link to="/settings" className={classes.link}>
                <ListItem button>
                  <ListItemIcon>
                    <SettingsIcon />
                  </ListItemIcon>
                  <ListItemText primary={I18n.t('menu.settings')} />
                </ListItem>
              </Link>
            </List>
          </div>
        </Drawer>
      </div>
    );
  }
}

function DefaultAppBar(props){
  const { classes } = props
  return(
    <AppBar position="fixed">
      <Toolbar>
        <IconButton className={classes.menuButton} onClick={props.toggleDrawer} color="inherit" aria-label="Menu">
          <MenuIcon />
        </IconButton>
        <Typography variant="title" color="inherit" className={classes.flex}>
          {(() => {
            switch(props.router.location.pathname) {
              case '/settings':
                return I18n.t('menu.settings')
              default:
                return I18n.t('global.title')
              }})()}
        </Typography>
        <Link to="/appointment/new" className={classes.linkButton}>
          <IconButton className={classes.addButton} color="inherit" aria-label="Add">
            <AddIcon />
          </IconButton>
        </Link>
      </Toolbar>
    </AppBar>
  )
}

function AppointmentAppBar(props){
  const { classes } = props
  return(
    <AppBar position="fixed">
      <Toolbar>
        <IconButton className={classes.menuButton} onClick={props.backEvent} color="inherit" aria-label="Menu">
          <BackIcon />
        </IconButton>
        <Typography variant="title" color="inherit" className={classes.flex}>
          {I18n.t('global.title')}
        </Typography>
        <Link to="/appointment/new" className={classes.linkButton}>
          <IconButton className={classes.addButton} color="inherit" aria-label="Add">
            <AddIcon />
          </IconButton>
        </Link>
      </Toolbar>
    </AppBar>
  )
}

function CalendarAppBar(props){
  const { classes } = props
  return(
    <AppBar position="fixed">
      <Toolbar>
        <IconButton className={classes.menuButton} onClick={props.toggleDrawer} color="inherit" aria-label="Menu">
          <MenuIcon />
        </IconButton>
        <IconButton color="inherit" aria-label="Previous" onClick={props.previousMonth}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="title" color="inherit" className={`${classes.flex} ${classes.title}`}>
          { props.calendar.date === null ? (
            null
          ) : (
            props.calendar.date.locale(props.i18n.locale).format('MMMM YYYY')
          )}
        </Typography>
        <IconButton color="inherit" aria-label="Next" onClick={props.nextMonth}>
          <ArrowNextIcon />
        </IconButton>
        <Link to="/appointment/new" className={classes.linkButton}>
          <IconButton className={classes.addButton} color="inherit" aria-label="Add">
            <AddIcon />
          </IconButton>
        </Link>
      </Toolbar>
    </AppBar>
  )
}

function WeekAppBar(props){
  const { classes } = props
  return(
    <AppBar position="fixed">
      <Toolbar>
        <IconButton className={classes.menuButton} onClick={props.toggleDrawer} color="inherit" aria-label="Menu">
          <MenuIcon />
        </IconButton>
        <IconButton color="inherit" aria-label="Previous" onClick={props.previousMonth}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="title" color="inherit" className={`${classes.flex} ${classes.title}`}>
          { props.week.date === null ? (
            null
          ) : (
            <span>{I18n.t('global.week')} {props.week.date.format('WW')} {props.week.date.format('YYYY')}</span>
          )}
        </Typography>
        <IconButton color="inherit" aria-label="Next" onClick={props.nextMonth}>
          <ArrowNextIcon />
        </IconButton>
        <Link to="/appointment/new" className={classes.linkButton}>
          <IconButton className={classes.addButton} color="inherit" aria-label="Add">
            <AddIcon />
          </IconButton>
        </Link>
      </Toolbar>
    </AppBar>
  )
}

function NewAppointmentAppBar(props){
  const { classes } = props
  return(
    <AppBar position="fixed">
      <Toolbar>
        <IconButton className={classes.menuButton} onClick={props.backEvent} color="inherit" aria-label="Menu">
          <BackIcon />
        </IconButton>
        <Typography variant="title" color="inherit" className={classes.flex}>
          {I18n.t('editAppointment.new_appointment')}
        </Typography>
        <IconButton className={classes.addButton} onClick={props.addNewAppointment} color="inherit" aria-label="Menu">
          <DoneIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  )
}

function UpdateAppointmentAppBar(props){
  const { classes } = props
  return(
    <AppBar position="fixed">
      <Toolbar>
        <IconButton className={classes.menuButton} onClick={props.backEvent} color="inherit" aria-label="Menu">
          <BackIcon />
        </IconButton>
        <Typography variant="title" color="inherit" className={classes.flex}>
          {I18n.t('editAppointment.update_appointment')}
        </Typography>
        <IconButton className={classes.addButton} onClick={props.updateAppointment} color="inherit" aria-label="Menu">
          <DoneIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  )
}

NavBar.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch
})

const mapStateToProps = (state) => ({
  router: state.router,
  calendar: state.calendar,
  user: state.user,
  otherUser: state.otherUser,
  week: state.week,
  i18n: state.i18n,
  newAppointment: state.newAppointment,
  updateAppointment: state.updateAppointment
})

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(NavBar))



// WEBPACK FOOTER //
// ./src/js/components/NavBar.js